import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import { getProductLogo } from '../utils/branding';
import bgImg from '../images/bg2.png';

const ApplicationLayoutContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${props => props.theme.BLACK};
  background-image: url(${bgImg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;

  #ApplicationContainer {
    margin-top: 102px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    @media (min-width: 768px) {
      margin-top: 132px;
    }

    @media (min-width: 992px) {
      margin-top: 232px;
    }

    img {
      width: 172px;
    }

    #InputContainer {
      margin-top: 31px;
      width: 100%;
      padding: 0px 40px;

      @media (min-width: 768px) {
        width: 350px;
        padding: 0px;
      }

      h1 {
        color: ${props => props.theme.WHITE};
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 40px;
      }
    }
  }
`;

function ApplicationLayout({
  children,
  displayFormHeadline,
  formHeadline,
  t,
  branding,
}) {
  return (
    <ApplicationLayoutContainer>
      <div id="ApplicationContainer">
        <img id="SSO.Logo" src={getProductLogo(branding)} alt={t('Logo')} />
        <div id="InputContainer">
          {displayFormHeadline && <h1 id="SSO.FormHeadline">{formHeadline}</h1>}
          {children}
        </div>
      </div>
    </ApplicationLayoutContainer>
  );
}

ApplicationLayout.propTypes = {
  t: PropTypes.func.isRequired, // supplied from withTranslation
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  displayFormHeadline: PropTypes.bool,
  formHeadline: PropTypes.string.isRequired,
  branding: PropTypes.string.isRequired,
};

ApplicationLayout.defaultProps = {
  displayFormHeadline: true,
};

export default withTranslation()(ApplicationLayout);
